<ra-modal
    [title]="(step() === 'root' ? 'order.documentOptions.modalTitle' : 'order.documentOptions.contractStepTitle') | translate"
    (close)="close.emit()">

    <div class="create-document-options">

        @if (step() === 'root') {

            <div class="options-step">
                <!-- Documento normal (em branco) -->
                <document-item
                    [id]="'document-item-blank'"
                    [icon]="'file'"
                    [color]="'blue'"
                    [title]="'order.documentOptions.blankDocument' | translate"
                    [description]="'order.documentOptions.blankDocumentDescription' | translate"
                    (click)="createBlankDocument.emit()"
                />

                <!-- Contrato (abre as sub-opções) -->
                <document-item
                    [id]="'document-item-contract'"
                    [icon]="'pen-draw'"
                    [color]="'green'"
                    [title]="'order.documentOptions.contract' | translate"
                    [description]="'order.documentOptions.contractDescription' | translate"
                    (click)="step.set('contract')"
                />

                <!-- Orçamento -->
                <document-item
                    [id]="'document-item-quote'"
                    [icon]="'dollar-circle'"
                    [color]="'orange'"
                    [title]="'order.documentOptions.quote' | translate"
                    [description]="'order.documentOptions.quoteDescription' | translate"
                    (click)="createQuote.emit()"
                />

                <!-- Importar arquivos (word/pdf/excel/powerpoint → documento) -->
                @if (!featureFlagController.isBlocked('import_files')) {
                    <document-item
                        [id]="'document-item-import'"
                        [icon]="'document-upload'"
                        [color]="'neutral'"
                        [title]="'order.documentImport.entryTitle' | translate"
                        [description]="'order.documentImport.entryDescription' | translate"
                        (click)="importFiles.emit()"
                    />
                }
            </div>

        } @else {

            <div class="options-step">
                <!-- Contrato em branco -->
                <document-item
                    [id]="'document-item-contract-blank'"
                    [icon]="'text'"
                    [color]="'neutral'"
                    [title]="'order.documentOptions.contractBlank' | translate"
                    [description]="'order.documentOptions.contractBlankDescription' | translate"
                    (click)="createBlankContract.emit()"
                />

                <!-- Modelos RapiDocs (modelos internos) -->
                <document-item
                    [id]="'document-item-contract-templates'"
                    [icon]="'copy'"
                    [color]="'neutral'"
                    [title]="'order.documentOptions.contractTemplates' | translate"
                    [description]="'order.documentOptions.contractTemplatesDescription' | translate"
                    (click)="useInternalTemplate.emit()"
                />

                <!-- Gerar com IA (em breve) -->
                <document-item
                    [id]="'document-item-contract-ai'"
                    [icon]="'magicpen'"
                    [color]="'neutral'"
                    [disabled]="true"
                    [badge]="'order.documentOptions.comingSoon' | translate"
                    [title]="'order.documentOptions.contractAi' | translate"
                    [description]="'order.documentOptions.contractAiDescription' | translate"
                />

                <!-- Rodapé: voltar para a lista de tipos (padrão das modais multi-etapas) -->
                <div class="options-actions">
                    <ra-button
                        [id]="'button-back-create-document'"
                        [label]="'order.common.back' | translate"
                        [type]="'primary-outline'"
                        (click)="step.set('root')"
                    />
                </div>
            </div>
        }
    </div>
</ra-modal>
